import { Injectable }               from '@angular/core';
import { Http,
         Response,
         Headers,
         RequestOptions,
         URLSearchParams }          from '@angular/http';
import { ISortableFilter,
         SortableFilter }           from './../common/sortable-filter';
import { Globals }                  from './../common/globals';
import { AuthHttp }                 from 'angular2-jwt';
import { Observable }               from 'rxjs/Observable';
import { objectToParams }           from './../common/functions';
import { GridInterfaceService }     from './grid.interface.service';
import { DynamicReportFilter }      from './../monitoring/dynamic-report-filter';
import fileSaver                     = require('file-saver');
import { MatSnackBar }               from '@angular/material';

@Injectable()
export class CommonService implements GridInterfaceService {

    private _api: string;

    public GetApi() {
        return this._api;
    }

    constructor(public authHttp: AuthHttp,
        private http: Http,
        private globals: Globals,
        private api: string,
        public snackbar: MatSnackBar) {

        this._api = '/api/' + api + '/';
    }

    public get(urlSuffix: string, filter: ISortableFilter = null): Observable<any> {

        let isFuckingIE = (navigator.appName === 'Microsoft Internet Explorer' ||
                            !!(navigator.userAgent.match(/Trident/) ||
                            navigator.userAgent.match(/rv:11/)));

        if (isFuckingIE) {
            if (!!filter) {
                filter.noCache = new Date().getTime();
            } else {
                filter = new SortableFilter(null);
                filter.noCache = new Date().getTime();
            }
        }

        let headers = new Headers({ 'Content-Type': 'application/json' });
        let stringParams = (filter === null) ? '' : objectToParams(filter);
        stringParams += ((filter === null) ? '' : '&') + 'businessType=' + this.globals.portalType;

        let searchParams = new URLSearchParams(stringParams);
        let options = new RequestOptions({ headers: headers, search: searchParams });

        let request = this.authHttp.get(this.globals.GetUrlPrefix() + this._api + urlSuffix, options);
        // return request;
        let response = request
            .map((res: Response) => {
                return res.json();
            })
            .catch((error: any) => {
                return Observable.throw(error.json() || error);
            });
        return response;
    }

    public getItems(filter: ISortableFilter): Observable<any> {
        return this.get('filter', filter);
    }

    public insertItem(item: any): Observable<any> {
        return this.post('', item);
    }

    public post(urlSuffix: string, item: any): Observable<any> {

        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let url = this.globals.GetUrlPrefix() + this._api + urlSuffix + '?businessType=' + this.globals.portalType;
        let request = this.authHttp.post(url, item, options);
        let response = request
            .timeout(item.Timeout || 10000)
            .map((res: Response) => {
                return res.text().length ? res.json() : '';
            })
            .catch((error: any) => {
                return Observable.throw(error.json() || error);
            });
        return response;
    }

    public pdfUrl(filter: ISortableFilter, columnParams: Array<any>): string {
        let stringParams = (filter === null) ? '' : objectToParams(filter);
        stringParams += ((filter === null) ? '?' : '&') + 'businessType=' + this.globals.portalType;
        if (!!columnParams && columnParams.length > 0) {
            stringParams += ('&columnParams=' + JSON.stringify(columnParams)) ;
        }
        return this.globals.GetUrlPrefix() + this._api + 'pdf?' + stringParams;
    }

    public pdf(filter: ISortableFilter, columnParams: Array<any>, pageOrientation: string = null) {
        if (filter instanceof DynamicReportFilter) {
            (<DynamicReportFilter>filter).Parameters.forEach((val) => {
                if (typeof val.Value.getMonth === 'function') {
                    val.Value = val.Value.toJSON();
                }});
        }
        let snack = this.snackbar;
        let o = (pageOrientation === 'horizontal' || pageOrientation === 'landscape' ||
                 pageOrientation === 'H' || pageOrientation === 'h') ?
                 'horizontal' : 'vertical';

        let pending = true;
        let xhr = new XMLHttpRequest();
        let stringParams = (filter === null) ? '' : objectToParams(filter);
        stringParams += ('&orientation=' + o);
        stringParams += '&businessType=' + this.globals.portalType;
        let url = this.globals.GetUrlPrefix() + this._api + 'pdf?' + stringParams;
        xhr.open('POST', url, true);
        xhr.responseType = 'blob';
        let bodyContent = JSON.stringify(columnParams);
        let globals = this.globals;

        xhr.onreadystatechange = function() {
            // We use setTimeout to trigger change detection in Zones
            setTimeout( () => { pending = false; }, 0);

            // If we get an HTTP status OK (200), save the file using fileSaver
            if (xhr.readyState === 4 && xhr.status === 200) {
                let blob = new Blob([this.response], {type: 'application/pdf'});
                let fileName = 'report.pdf';
                let disposition = xhr.getResponseHeader('Content-Disposition');
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    let matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        fileName = matches[1].replace(/['"]/g, '');
                    }
                }
                fileSaver.saveAs(blob, fileName);

                globals.isDownloadingPdf = false;
            } else if (xhr.readyState === 4 && xhr.status !== 200) {
                snack.open('Při generování PDF se vyskytla chyba. Kontaktujte prosím podporu.', 'Zavřít');
            }
        };

        let auth = sessionStorage.getItem('id_token');
        xhr.setRequestHeader('Authorization', 'Bearer ' + auth);
        xhr.setRequestHeader('Content-Type', 'application/json');
        // Start the Ajax request
        xhr.send(bodyContent);
    }

    public csv(filter: ISortableFilter, columnParams: Array<any>, pageOrientation: string = null) {

        if (filter instanceof DynamicReportFilter) {
            (<DynamicReportFilter>filter).Parameters.forEach((val) => {
                if (typeof val.Value.getMonth === 'function') {
                    val.Value = val.Value.toJSON();
                }});
        }

        let snack = this.snackbar;
        let pending = true;
        let xhr = new XMLHttpRequest();
        let stringParams = (filter === null) ? '' : objectToParams(filter);
        stringParams += '&businessType=' + this.globals.portalType;
        let url = this.globals.GetUrlPrefix() + this._api + 'csv?' + stringParams;
        xhr.open('POST', url, true);
        xhr.responseType = 'blob';
        let bodyContent = JSON.stringify(columnParams);
        let globals = this.globals;

        xhr.onreadystatechange = function() {
            // We use setTimeout to trigger change detection in Zones
            setTimeout( () => { pending = false; }, 0);

            // If we get an HTTP status OK (200), save the file using fileSaver
            if (xhr.readyState === 4 && xhr.status === 200) {
                let blob = new Blob([this.response], {type: 'text/csv'});
                let fileName = 'report.csv';
                let disposition = xhr.getResponseHeader('Content-Disposition');
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    let matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        fileName = matches[1].replace(/['"]/g, '');
                    }
                }
                fileSaver.saveAs(blob, fileName);

                globals.isDownloadingCsv = false;
            } else if (xhr.readyState === 4 && xhr.status !== 200) {
                snack.open('Při generování PDF se vyskytla chyba. Kontaktujte prosím podporu.', 'Zavřít');
            }
        };

        let auth = sessionStorage.getItem('id_token');
        xhr.setRequestHeader('Authorization', 'Bearer ' + auth);
        xhr.setRequestHeader('Content-Type', 'application/json');
        // Start the Ajax request
        xhr.send(bodyContent);
    }

    public updateItem(id: string, item: any): Observable<any> {

        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });

        let request = this.authHttp.put(this.globals.GetUrlPrefix() + this._api + id, item, options);
        let response = request
            .map((res: Response) => {
                return res.json();
            })
            .catch((error: any) => {
                return Observable.throw(error.json() || error);
            });
        return response;
    }

    public deleteItem(id: string): Observable<any> {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });

        let request = this.authHttp.delete(this.globals.GetUrlPrefix() + this._api + id, options);
        return request;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/common.service.ts